import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  Button,
  Card,
  CardContent,
} from '@mui/material';
import { Grid } from '@mui/material';
import {
  Psychology,
  Work,
  TrendingUp,
  EmojiEvents,
} from '@mui/icons-material';

const Home: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5' }}>
      {/* ヘッダー */}
      <Box
        sx={{
          bgcolor: '#0066cc',
          color: 'white',
          py: 3,
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h4"
            component="h1"
            sx={{
              fontWeight: 600,
              fontSize: { xs: '1.5rem', md: '2rem' },
            }}
          >
            アスリート向けキャリア診断システム
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ py: 6 }}>
        {/* メインビジュアル */}
        <Box
          sx={{
            bgcolor: 'white',
            borderRadius: 2,
            p: 6,
            mb: 6,
            textAlign: 'center',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          }}
        >
          <Typography
            variant="h3"
            component="h2"
            gutterBottom
            sx={{
              color: '#333',
              fontWeight: 600,
              fontSize: { xs: '1.75rem', md: '2.5rem' },
              mb: 3,
            }}
          >
            あなたに合った職業を見つけましょう
          </Typography>
          <Typography
            variant="h6"
            sx={{
              color: '#666',
              mb: 4,
              fontSize: { xs: '1rem', md: '1.25rem' },
              lineHeight: 1.8,
            }}
          >
            スポーツで培った経験やスキルを活かせる、<br />
            最適なキャリアを診断します
          </Typography>
          <Button
            variant="contained"
            size="large"
            sx={{
              bgcolor: '#0066cc',
              color: 'white',
              px: 8,
              py: 2,
              fontSize: '1.1rem',
              fontWeight: 600,
              borderRadius: 2,
              boxShadow: '0 4px 12px rgba(25,118,210,0.3)',
              '&:hover': {
                bgcolor: '#0052a3',
                boxShadow: '0 6px 16px rgba(25,118,210,0.4)',
              },
            }}
            onClick={() => navigate('/assessment')}
          >
            診断を始める
          </Button>
        </Box>

        {/* 診断内容の紹介 */}
        <Box sx={{ mb: 6 }}>
          <Typography
            variant="h5"
            component="h3"
            gutterBottom
            sx={{
              color: '#333',
              fontWeight: 600,
              mb: 4,
              pb: 2,
              borderBottom: '3px solid #0066cc',
            }}
          >
            診断内容
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={3}>
              <Card
                sx={{
                  height: 280,
                  display: 'flex',
                  flexDirection: 'column',
                  textAlign: 'center',
                  border: '1px solid #e0e0e0',
                  boxShadow: 'none',
                  transition: 'all 0.3s',
                  '&:hover': {
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    transform: 'translateY(-4px)',
                  },
                }}
              >
                <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', p: 3 }}>
                  <Psychology sx={{ fontSize: 64, color: '#0066cc', mb: 2, mx: 'auto' }} />
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#333' }}>
                    社会人基礎能力
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#666', lineHeight: 1.7 }}>
                    チームワーク、目標達成力、メンタルタフネスなど5つの能力を診断
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Card
                sx={{
                  height: 280,
                  display: 'flex',
                  flexDirection: 'column',
                  textAlign: 'center',
                  border: '1px solid #e0e0e0',
                  boxShadow: 'none',
                  transition: 'all 0.3s',
                  '&:hover': {
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    transform: 'translateY(-4px)',
                  },
                }}
              >
                <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', p: 3 }}>
                  <Work sx={{ fontSize: 64, color: '#0066cc', mb: 2, mx: 'auto' }} />
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#333' }}>
                    職業興味検査
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#666', lineHeight: 1.7 }}>
                    RIASEC理論に基づいた6つの職業タイプから適性を分析
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Card
                sx={{
                  height: 280,
                  display: 'flex',
                  flexDirection: 'column',
                  textAlign: 'center',
                  border: '1px solid #e0e0e0',
                  boxShadow: 'none',
                  transition: 'all 0.3s',
                  '&:hover': {
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    transform: 'translateY(-4px)',
                  },
                }}
              >
                <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', p: 3 }}>
                  <TrendingUp sx={{ fontSize: 64, color: '#0066cc', mb: 2, mx: 'auto' }} />
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#333' }}>
                    ポータブルスキル
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#666', lineHeight: 1.7 }}>
                    どの職業でも活かせる8つのスキルを可視化
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Card
                sx={{
                  height: 280,
                  display: 'flex',
                  flexDirection: 'column',
                  textAlign: 'center',
                  border: '1px solid #e0e0e0',
                  boxShadow: 'none',
                  transition: 'all 0.3s',
                  '&:hover': {
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    transform: 'translateY(-4px)',
                  },
                }}
              >
                <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', p: 3 }}>
                  <EmojiEvents sx={{ fontSize: 64, color: '#0066cc', mb: 2, mx: 'auto' }} />
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#333' }}>
                    109種類の職業
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#666', lineHeight: 1.7 }}>
                    アスリート経験を活かせる多様な職業をマッチング
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>

        {/* 職業一覧へのボタン */}
        <Box
          sx={{
            textAlign: 'center',
            bgcolor: 'white',
            borderRadius: 2,
            p: 5,
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          }}
        >
          <Typography variant="h6" sx={{ color: '#333', mb: 3 }}>
            どんな職業があるか見てみる
          </Typography>
          <Button
            variant="outlined"
            size="large"
            sx={{
              color: '#0066cc',
              borderColor: '#0066cc',
              borderWidth: 2,
              px: 6,
              py: 1.5,
              fontSize: '1.1rem',
              fontWeight: 600,
              borderRadius: 2,
              '&:hover': {
                borderColor: '#0066cc',
                borderWidth: 2,
                bgcolor: '#f5f9ff',
              },
            }}
            onClick={() => navigate('/careers')}
          >
            職業一覧を見る
          </Button>
        </Box>

      </Container>
    </Box>
  );
};

export default Home;
